import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GenericTransit, GetCognitoUserState, LoginResponseEncrypt, loginStart } from '../auth/interface/auth.interface';
import { GenericResponse } from '../../shared/interface/generic.interface';
import { environment as env } from '../../../environments/environment';
import { localDB } from '../../shared/helpers/localStorage';
import { Data } from '../auth/interface/auth.interface';
import { ConfigEnviromentService } from './configEnviroment.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userData: any;
  isAuthenticatedUser = new BehaviorSubject<boolean>(false);
  isAuthenticatedUser$ = this.isAuthenticatedUser.asObservable();

  constructor(
    private http: HttpClient,
    private configService: ConfigEnviromentService
  ) { }

  GetUserState(sEmail: string, sClave: string) {
    return this.http.get<GenericResponse<GetCognitoUserState>>(
      `${env.api_url}api/userState?sEmail=${sEmail}&sClave=${sClave}`
    );
  }

  UserChallenge(data: loginStart) {
    return this.http.post<LoginResponseEncrypt>(`${env.api_url}api/MFAChallenge`, data);
  }

  SetPreferedMfa(data: GenericTransit) {
    return this.http.post<GenericResponse<string>>(`${env.api_url}api/MFAPreference`, data);
  }

  ConfirmCode(data: loginStart) {
    return this.http.post<LoginResponseEncrypt>(`${env.api_url}api/ConfirmCode`, data);
  }

  Verify(data: GenericTransit) {
    return this.http.post<LoginResponseEncrypt>(`${env.api_url}api/verify`, data);
  }

  SetPassword(data: loginStart) {
    return this.http.post<LoginResponseEncrypt>(`${env.api_url}api/SetPassword`, data);
  }

  login(data: loginStart, type: string) {
    return this.http.post<LoginResponseEncrypt>(`${env.api_url}api/login?auth_type=${type}`, data);
  }

  PhotoGmailUpdate(data: { sUrl_Foto: string }): Observable<GenericResponse<boolean>> {
    return this.http.put<GenericResponse<boolean>>(
      `${env.api_url}api/colaborador/actualizarFoto`,
      data
    );
  }

  logout(): Observable<GenericResponse<boolean>> {
    this.isAuthenticatedUser.next(false);
    return this.http.put<GenericResponse<boolean>>(`${env.api_url}api/logout`, null);
  }

  isAuthenticated(): boolean {
    const token = localDB.getItem('token');
    return !!token;
  }

  initData(data: Data) {
    localDB.setItem('idUsuario', data.nId_Usuario.toString());
  }

  get idUsuario(): string | null {
    return localDB.getItem('idUsuario');
  }
}
